// store/modules/geofencing.js
import Vue from 'vue';
import api from '@/api';
import { createSyncState, recordWrite, createSyncRequest, mergeSyncResponse, schemaKinds, defineSyncSchema, syncMutations } from '@/helpers/storeSync';

const GEOFENCING_SYNC_SCHEMA = defineSyncSchema({ key: 'ID_GEOFENCING', kind: 'geofencing', insertAt: 'end' });

const state = {
  geofencings: [],
  sync: createSyncState(schemaKinds(GEOFENCING_SYNC_SCHEMA)),
};

const getters = {
  getGeofencingsByEmergencia: (state) => (idEmergencia) =>
    state.geofencings.filter((x) => x.ID_EMERGENCIA?.equalsIgnoreCase(idEmergencia)),
};

const mutations = {
  ...syncMutations,

  MERGE_GEOFENCINGS(state, { rows, request }) {
    state.geofencings = mergeSyncResponse(state.sync, state.geofencings, rows, GEOFENCING_SYNC_SCHEMA, request);
  },

  SOCKET_addGeofencing(state, geofencing) {
    const index = state.geofencings.findIndex((x) => x.ID_GEOFENCING?.equalsIgnoreCase(geofencing.ID_GEOFENCING));

    if (index !== -1) {
      Vue.set(state.geofencings, index, geofencing);
    } else {
      state.geofencings.push(geofencing);
    }

    recordWrite(state.sync, 'geofencing', geofencing.ID_GEOFENCING);
  },

  SOCKET_updateGeofencing(state, geofencing) {
    const index = state.geofencings.findIndex((x) => x.ID_GEOFENCING?.equalsIgnoreCase(geofencing.ID_GEOFENCING));

    if (index !== -1) {
      Vue.set(state.geofencings, index, geofencing);
      recordWrite(state.sync, 'geofencing', geofencing.ID_GEOFENCING);
    }
  },

  UPDATE_GEOFENCING_RECURSO_SECTOR(state, { idGeofencing, idRecursoSector }) {
    const index = state.geofencings.findIndex((x) => x.ID_GEOFENCING?.equalsIgnoreCase(idGeofencing));

    if (index === -1) {
      console.warn(`[geofencing] No se encontró el geofencing ${idGeofencing} en el store`);
      return;
    }

    Vue.set(state.geofencings, index, {
      ...state.geofencings[index],
      ID_RECURSO_SECTOR: idRecursoSector,
    });

    recordWrite(state.sync, 'geofencing', idGeofencing);
  },
};

const actions = {
  async fetchGeofencings({ commit, state }) {
    try {
      commit('BEGIN_SYNC_REQUEST');
      const request = createSyncRequest(state.sync.seq);
      const response = await api.geofencing.getAll();
      commit('MERGE_GEOFENCINGS', { rows: response.data, request });
    } catch (error) {
      console.error('[geofencing] Error al cargar los geofencings:', error);
      throw error;
    }
  },

  async updateGeofencing({ commit }, geofencing) {
    try {
      const response = await api.geofencing.update(geofencing);
      const resultado = response.data;

      const [idRecursoSector] = resultado?.idsRecursoSector || [];

      if (!idRecursoSector) {
        throw new Error('El servidor no ha devuelto el ID_RECURSO_SECTOR creado.');
      }

      commit('UPDATE_GEOFENCING_RECURSO_SECTOR', {
        idGeofencing: geofencing.ID_GEOFENCING,
        idRecursoSector,
      });

      return resultado;
    } catch (error) {
      console.error('[geofencing] Error al actualizar el geofencing:', error);
      throw error;
    }
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
